import { Link } from '@chegg-ui/link'
import { Config } from '@chegg-wt/core/config'
import { BibliographyB1Copy } from '@chegg-wt/core/types/copy'

export const bibliographyB1: BibliographyB1Copy = {
  title: 'Helpful Tips for Your Citation',
  contents: [
    {
      header: 'Consider source credibility',
      body: () => (
        <div>
          Remember to evaluate your sources for credibility. Review factors such as
          information currency, relevance, and accuracy. Consider the author and
          publisher’s authority and purpose. This step is important since questionable
          sources could result in a poor grade.
        </div>
      ),
    },
    {
      header: 'Check for plagiarism',
      body: () => (
        <div>
          Any sign of plagiarism can kill your grade and credibility. Don’t leave your
          paper’s fate to chance. Scan your paper with{' '}
          <Link href={`${Config.baseUrl}/grammar-and-plagiarism/`}>
            our plagiarism checker
          </Link>{' '}
          and spot potential red flags before they become problems.
        </div>
      ),
    },
    {
      header: 'Add in-text citations',
      body: () => (
        <div>
          Creating parenthetical citations (MLA, APA) and footnotes (Chicago) for your
          paper is simple with the BibMe in-text citation tool. To use the tool, go to
          your citation list, click the three dots next to a citation, and select
          &quot;Copy in-text-citation&quot; or &quot;Copy footnote&quot;. You can copy and
          paste the in-text citation shown or edit it as needed.
        </div>
      ),
    },
    {
      header: 'Build an annotated bibliography',
      body: () => (
        <div>
          If required by your instructor, you can add annotations to your citations. Just
          select &quot;Add Annotation&quot; while finalizing your citation. You can always
          go back and edit a citation or annotation later.
        </div>
      ),
    },
    {
      header: 'Cite in a style of your choice',
      body: () => (
        <div>
          BibMe offers over 7,000+ styles including APA, MLA, and Chicago. Even if you’ve
          already started building a bibliography, the style can be changed, if needed.
        </div>
      ),
    },
    {
      header: 'Start citing by selecting your source type',
      body: () => (
        <div>
          Take a look at our list of more than 50 source types and choose the one that
          best describes what you’re citing.
        </div>
      ),
    },
    {
      header: 'Learn the ins and outs of citing',
      body: () => (
        <div>
          Read{' '}
          <Link href={`${Config.baseUrl}/citation-guide`}>BibMe citation guides</Link> for
          detailed information about various types of sources in MLA, APA, Chicago and
          Turabian styles.
        </div>
      ),
    },
  ],
}
